import React from 'react';
import { motion } from 'framer-motion';
export function TheProblem() {
  return <section className="w-full bg-taupe/20 py-20 md:py-28" data-id="element-92">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown mb-8 text-center tracking-wide" data-id="element-95">
            No es "parte de la edad".
          </h2>
          <div className="space-y-6 text-lg text-text-brown-light font-light leading-relaxed" data-id="element-96">
            <p data-id="element-97">
              La mayoría de las mujeres de 40+ aceptan este agotamiento como
              "parte de la edad". Te han dicho que es normal sentirte como una
              extraña en su propio cuerpo, que la irritabilidad es inevitable y
              que el insomnio es tu nueva realidad.
            </p>
            <p className="font-medium text-text-brown" data-id="element-98">Pero no es normal.</p>
            <p data-id="element-99">
              Es un desajuste de señales biológicas que tu cuerpo está gritando
              que corrijas. Estás atrapada en el ciclo de "supervivencia" y tu
              carrera, tu familia y tu paz mental están pagando el precio.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}